// removed by extract-text-webpack-plugin
module.exports = {"pageWrapper":"gn1bU3uTaoNb5te1jpPSA","title":"_278QxsCX61JZsr8jmhrA5x","subscriptionList":"_3ACnd7_7jcaMK4wy0-gaqC","spinnerPosition":"_11SLQi6iToAssXYrTa6afB","spinner":"Rv4SVlTTInbCz09h7qdez","titles":"_3MF66EMpYb5Z2nq0zGWRUW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SubscriptionsContainer/SubscriptionsContainer.scss
// module id = 1852
// module chunks = 0